'use client'

import ImageViverseLogoText from '@/public/images/viverse-logo-text.png'
import ImageViverseLogo from '@/public/images/viverse-logo.png'
import Image from 'next/image'

const ShimmerLogo = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <Image src={ImageViverseLogo} alt="VIVERSE logo" width={90} height={78} className="mb-4.5" />
      <Image
        src={ImageViverseLogoText}
        alt="VIVERSE"
        width={150}
        height={20}
        style={{
          mask: 'linear-gradient(-45deg, #000 30%, #0005, #000 70%) right/350% 100%',
          animation: 'shimmer 1.4s infinite',
        }}
      />

      <style jsx scoped>
        {`
          @keyframes shimmer {
            100% {
              mask-position: left;
            }
          }
        `}
      </style>
    </div>
  )
}

export default ShimmerLogo
